// @core/api/endpoints/platform/check_federation_health.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckFederationHealthRequest,
  FederationHealthCheckResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Check federation health
 * Triggers an on-demand health check for a federation peer. Returns connectivity, latency, sync status, and certificate validity.
 */
export async function CheckFederationHealth(
  peer_id: string,
  data: CheckFederationHealthRequest,
  options?: RequestOptions
): Promise<FederationHealthCheckResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id/health`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.post<FederationHealthCheckResponse>(requestPath, data, requestOptions);
}
